import { HubLoanerPhoneListSearchCriteria } from '../../models/hub-loaner-phones.model';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../../ui-kit';

export class HubLoanerPhoneListLoad {
  public static readonly type = '[HubLoanerPhoneList] Load Loaner Phone List';

  constructor(
    public payload: {
      hubId: number;
      searchCriteria: HubLoanerPhoneListSearchCriteria;
    },
  ) {}
}

export class HubLoanerPhoneListItemReturn {
  public static readonly type = '[HubLoanerPhoneList] Return Loaner Phone List';

  constructor(
    public payload: {
      dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>;
      hubId: number;
      id: number;
      returnTimestamp: number;
      searchCriteria: HubLoanerPhoneListSearchCriteria;
    },
  ) {}
}

export class HubLoanerPhoneListItemDelete {
  public static readonly type = '[HubLoanerPhoneList] Delete Loaner Phone List';

  constructor(
    public payload: {
      dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>;
      hubId: number;
      id: number;
      searchCriteria: HubLoanerPhoneListSearchCriteria;
    },
  ) {}
}

export class HubLoanerPhoneListInitialState {
  public static readonly type = '[HubLoanerPhoneList] Set Initial State';
}
